import React from 'react';
import PropTypes from 'prop-types';
import { COST_OBJ_PROP_TYPE } from 'shared/constants/PropTypes';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';
import ManageCostObjLocations from './ManageCostObjLocationsConnector';
import ManageCostObjAllocationUnits from './ManageCostObjAllocationUnitsConnector';

const inputStyle = { width: '50%', display: 'block' };

class CostObjEditor extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      costObj: {
        ...props.costObj,
        locationDtoList: [
          ...props.costObj.locationDtoList
        ],
        allocationUnitDtos: [
          ...props.costObj.allocationUnitDtos
        ]
      }
    };
  }

  handleInputChange = (ev, value) => {
    const target = ev.target;
    this.props.onChangeField(target.name, value);
    this.setState(oldState => ({ costObj: { ...oldState.costObj, [target.name]: value } }));
  };

  handleLocationChange = (newLocations) => this.props.onLocationChange(newLocations);

  handleAllocationUnitChange = (newCostObjAllocationUnits) => this.props.onAllocationUnitChange(newCostObjAllocationUnits);

  render() {
    const { costObj } = this.state;
    return (
      <div>
        <MaterialTextField
          name={ 'name' }
          label={ 'Name' }
          value={ costObj.name }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          disabled={ costObj.id }
          required
        />
        <MaterialTextField 
          name={ 'description' }
          label={ 'Description (Optional)' }
          value={ costObj.description }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
        />
        <h4 className="cost-obj-section-header">Location</h4>
        <ManageCostObjLocations
          locations={ costObj.locationDtoList }
          onLocationChange={ this.handleLocationChange }
        />
        <h4 className="cost-obj-section-header">Entity / Use</h4>
        <MaterialTextField 
          name={ 'entityCode' }
          label={ 'Entity Use Code' }
          value={ costObj.entityCode }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
        />
        <h4 className="cost-obj-section-header">Good / Service Code</h4>
        <MaterialTextField 
          name={ 'goodServiceCode' }
          label={ 'Good Service Code' }
          value={ costObj.goodServiceCode }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
        />
        <h4 className="cost-obj-section-header">Allocation Units</h4>
        <ManageCostObjAllocationUnits
          costObjAllocationUnits={ costObj.allocationUnitDtos }
          onAllocationUnitChange={ this.handleAllocationUnitChange }
        />
      </div>
    );
  }
}

CostObjEditor.propTypes = {
  onChangeField: PropTypes.func.isRequired,
  costObj: COST_OBJ_PROP_TYPE.isRequired,
  onLocationChange: PropTypes.func.isRequired,
  onAllocationUnitChange: PropTypes.func.isRequired
};

export default CostObjEditor;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/CostObjEditor.js